import React, { Fragment } from "react";
import { Container, Row, Col } from "react-bootstrap";

const Terms_Condition = () => {
  return (
    <Fragment>
      <div className="terms-page">
        <Container className="py-5">
          <div className="text-center mb-5">
            <h1 className="mb-3">Terms & Conditions</h1>
            <p className="text-muted">
              <strong>Last Updated: January 2025</strong>
            </p>
          </div>

          <Row>
            <Col md={12} className="mb-5">
              <div className="terms-box">
                <h3 className="mb-3">1. Acceptance of Terms</h3>
                <p>
                  By accessing or using Spark Lab's website (
                  <a href="https://sparklabpk.com">https://sparklabpk.com</a>)
                  or services, you agree to be bound by these Terms &
                  Conditions. If you do not agree with any part of these terms,
                  you must not use our services.
                </p>
              </div>
            </Col>

            <Col md={12} className="mb-5">
              <div className="terms-box">
                <h3 className="mb-3">2. Services Description</h3>
                <p>
                  Spark Lab provides Information Technology Services including:
                </p>
                <ul>
                  <li>Website design and development</li>
                  <li>Graphic and logo design</li>
                  <li>Social media marketing</li>
                  <li>Video editing and animation projects</li>
                </ul>
              </div>
            </Col>

            <Col md={12} className="mb-5">
              <div className="terms-box">
                <h3 className="mb-3">3. Use of Services</h3>

                <h5>Permitted Use:</h5>
                <p className="mb-3">
                  You agree to use Spark Lab services only for lawful purposes
                  and in accordance with these Terms & Conditions.
                </p>

                <h5>Prohibited Activities:</h5>
                <p>You must not:</p>
                <ul>
                  <li>
                    Use our services for any illegal, fraudulent, or harmful
                    activities
                  </li>
                  <li>
                    Attempt to gain unauthorized access to any part of our
                    services
                  </li>
                  <li>
                    Interfere with or disrupt the integrity or performance of
                    our services
                  </li>
                  <li>
                    Use our services to transmit any malicious software or code
                  </li>
                </ul>
              </div>
            </Col>

            <Col md={12} className="mb-5">
              <div className="terms-box">
                <h3 className="mb-3">4. Account Responsibilities</h3>
                <p>
                  If you create an account with us, you are responsible for:
                </p>
                <ul>
                  <li>
                    Maintaining the confidentiality of your account credentials
                  </li>
                  <li>All activities that occur under your account</li>
                  <li>
                    Immediately notifying us of any unauthorized access or
                    security breaches
                  </li>
                  <li>
                    Ensuring that your account information is accurate and
                    up-to-date
                  </li>
                </ul>
              </div>
            </Col>

            <Col md={12} className="mb-5">
              <div className="terms-box">
                <h3 className="mb-3">5. Intellectual Property</h3>

                <h5>Our Content:</h5>
                <p className="mb-3">
                  All content, logos, graphics, designs, software, and materials
                  on our website and services are owned by Spark Lab or our
                  licensors and are protected by intellectual property laws.
                </p>

                <h5>Your Content:</h5>
                <p className="mb-3">
                  By submitting content to us (designs, text, images, etc.), you
                  grant us a license to use, modify, and display that content as
                  necessary to provide our services.
                </p>

                <h5>Restrictions:</h5>
                <p>
                  You may not reproduce, distribute, modify, create derivative
                  works of, publicly display, or commercially exploit any of our
                  intellectual property without our express written permission.
                </p>
              </div>
            </Col>

            <Col md={12} className="mb-5">
              <div className="terms-box">
                <h3 className="mb-3">6. Payment and Fees</h3>

                <h5>Service Fees:</h5>
                <p className="mb-3">
                  All services are subject to the fees quoted at the time of
                  agreement. Prices are subject to change with prior notice.
                </p>

                <h5>Payment Terms:</h5>
                <ul>
                  <li>
                    Payment terms will be specified in your service agreement
                  </li>
                  <li>Late payments may be subject to interest charges</li>
                  <li>
                    We reserve the right to suspend services for non-payment
                  </li>
                </ul>
              </div>
            </Col>

            <Col md={12} className="mb-5">
              <div className="terms-box">
                <h3 className="mb-3">7. Limitation of Liability</h3>
                <p>
                  To the maximum extent permitted by law, Spark Lab shall not be
                  liable for:
                </p>
                <ul>
                  <li>
                    Any direct, indirect, incidental, special, or consequential
                    damages
                  </li>
                  <li>Loss of profits, data, or business opportunities</li>
                  <li>
                    Damages resulting from the use or inability to use our
                    services
                  </li>
                  <li>Third-party conduct or content</li>
                </ul>
              </div>
            </Col>

            <Col md={12} className="mb-5">
              <div className="terms-box">
                <h3 className="mb-3">8. Messaging Terms & Conditions</h3>

                <h5>SMS/Text Messaging Services:</h5>
                <p className="mb-3">
                  You agree to receive informational messages (appointment
                  reminders, account notifications, marketing communications,
                  etc.) from Spark Lab. These messages may include project
                  updates, meeting confirmations, support responses, and
                  follow-ups related to our IT services.
                </p>

                <h5>Message Frequency and Rates:</h5>
                <ul className="mb-3">
                  <li>
                    Message frequency varies based on your interactions with our
                    services
                  </li>
                  <li>Message and data rates may apply</li>
                </ul>

                <h5>Customer Care:</h5>
                <p className="mb-3">For help with our messaging services:</p>
                <ul className="mb-3">
                  <li>Reply HELP to receive assistance</li>
                  <li>
                    Email us at{" "}
                    <a href="mailto:hr@sparklabpk.com">hr@sparklabpk.com</a> for
                    support
                  </li>
                </ul>

                <h5>Opt-Out:</h5>
                <p className="mb-3">
                  You can opt out of receiving messages at any time by replying
                  STOP. Upon opting out, you will receive a confirmation message
                  and no further communications will be sent unless you opt back
                  in.
                </p>

                <h5>Carrier Compliance:</h5>
                <p>
                  Our messaging services comply with U.S. carrier requirements
                  and A2P 10DLC regulations. By opting into our SMS services,
                  you acknowledge that:
                </p>
                <ul>
                  <li>Message delivery is not guaranteed</li>
                  <li>
                    Carriers are not liable for delayed or undelivered messages
                  </li>
                  <li>
                    You are responsible for obtaining consent from message
                    recipients
                  </li>
                </ul>
              </div>
            </Col>

            <Col md={12} className="mb-5">
              <div className="terms-box">
                <h3 className="mb-3">9. Modifications to Services</h3>
                <p>We reserve the right to:</p>
                <ul>
                  <li>
                    Modify or discontinue any part of our services at any time
                  </li>
                  <li>Change pricing with reasonable notice</li>
                  <li>Update these Terms & Conditions as needed</li>
                  <li>
                    Suspend or terminate your access for violations of these
                    terms
                  </li>
                </ul>
              </div>
            </Col>

            <Col md={12} className="mb-5">
              <div className="terms-box">
                <h3 className="mb-3">10. Termination</h3>
                <p>
                  We may terminate or suspend your access to our services
                  immediately, without prior notice, for conduct that we believe
                  violates these Terms & Conditions or is harmful to other
                  users, us, or third parties.
                </p>
              </div>
            </Col>

            <Col md={12} className="mb-5">
              <div className="terms-box">
                <h3 className="mb-3">11. Governing Law</h3>

                <h5>Primary Jurisdiction:</h5>
                <p className="mb-3">
                  These Terms & Conditions are governed by and construed in
                  accordance with the laws of Pakistan. Any disputes will be
                  subject to the exclusive jurisdiction of the courts located in
                  Karachi, Pakistan.
                </p>

                <h5>U.S. Users:</h5>
                <p>
                  For users in the United States, SMS communications are subject
                  to U.S. telecommunications regulations and carrier
                  requirements. By opting into our SMS services, you acknowledge
                  compliance with applicable U.S. messaging laws and
                  regulations.
                </p>
              </div>
            </Col>

            <Col md={12} className="mb-5">
              <div className="terms-box">
                <h3 className="mb-3">12. Disclaimer of Warranties</h3>
                <p>
                  Our services are provided "as is" and "as available" without
                  any warranties of any kind, either express or implied. We do
                  not warrant that our services will be uninterrupted, secure,
                  or error-free.
                </p>
              </div>
            </Col>

            <Col md={12} className="mb-5">
              <div className="terms-box">
                <h3 className="mb-3">13. Indemnification</h3>
                <p>
                  You agree to indemnify and hold harmless Spark Lab, its
                  officers, directors, employees, and agents from any claims,
                  damages, losses, liabilities, and expenses arising from your
                  use of our services or violation of these Terms & Conditions.
                </p>
              </div>
            </Col>

            <Col md={12} className="mb-5">
              <div className="terms-box">
                <h3 className="mb-3">14. Severability</h3>
                <p>
                  If any provision of these Terms & Conditions is found to be
                  invalid or unenforceable, the remaining provisions will
                  continue to be valid and enforceable to the fullest extent
                  permitted by law.
                </p>
              </div>
            </Col>

            <Col md={12} className="mb-5">
              <div className="terms-box">
                <h3 className="mb-3">15. Entire Agreement</h3>
                <p>
                  These Terms & Conditions, together with our Privacy Policy,
                  constitute the entire agreement between you and Spark Lab
                  regarding your use of our services.
                </p>
              </div>
            </Col>

            <Col md={12} className="mb-5">
              <div className="terms-box">
                <h3 className="mb-3">16. Changes to These Terms</h3>
                <p>
                  We may update these Terms & Conditions from time to time. We
                  will notify you of any changes by posting the new Terms &
                  Conditions on this page and updating the "Last Updated" date.
                  Your continued use of our services after any changes
                  constitutes acceptance of those changes.
                </p>
              </div>
            </Col>

            <Col md={12}>
              <div className="terms-box">
                <h3 className="mb-3">17. Contact Information</h3>
                <p>
                  For questions regarding these Terms & Conditions, please
                  contact us:
                </p>
                <ul>
                  <li>
                    <strong>Email:</strong>{" "}
                    <a href="mailto:hr@sparklabpk.com">hr@sparklabpk.com</a>
                  </li>
                  <li>
                    <strong>Phone:</strong> +92 3335855502
                  </li>
                  <li>
                    <strong>Address:</strong> Plot 19 E Baddar Commercial Street
                    No. 5, Clifton, Karachi, Sindh 75500, Pakistan
                  </li>
                  <li>
                    <strong>Website:</strong>{" "}
                    <a href="https://sparklabpk.com">https://sparklabpk.com</a>
                  </li>
                </ul>
              </div>
            </Col>

            <Col md={12} style={{ paddingTop: "36px" }}>
              <div className="terms-box">
                <h3 className="mb-3">18. Contact Information</h3>
                <p>
                  You agree to receive informational messages (appointment
                  reminders, account notifications, etc.) from Spark Lab.
                  Message frequency varies. Message and data rates may apply.
                  For help, reply HELP or email us at hr@sparklabpk.com. You can
                  opt out at any time by replying STOP.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </Fragment>
  );
};

export default Terms_Condition;
